const legolasConfig = {
  url : process.env.REACT_APP_API_URL,
  sensiChannelId:process.env.SENSI_CHANNEL_ID
}

export default legolasConfig